import axios from "axios";
import isEmpty from "is-empty";
import { GET_ERRORS, WAPPER_ADD, WAPPER_UPDATE } from "./types";
import { db } from "../firebase";
import { collection, setDoc, doc, updateDoc } from "firebase/firestore";
import { toast, ToastContainer } from "react-toastify";

export const addWapper = (param, history) => async (dispatch) => {
  var wapperData = new FormData();

  wapperData.append("fromAddress", param.fromAddress);
  wapperData.append("amount", param.amount);

  console.log("wapperData>>>>>>>", wapperData);

  const wapperRef = doc(collection(db, "wappers"));
  const docRef = await setDoc(wapperRef, {
    id: wapperRef.id,
    fromAddress: param.fromAddress,
    amount: param.amount,
  });
  dispatch({
    type: WAPPER_ADD,
    payload: wapperRef,
  });
  toast("The transaction has been addedd", {
    position: toast.POSITION.TOP_CENTER,
  });
  // axios
  //     .post("/api/wapper-add", wapperData)
  //     .then(res =>{
  //         console.log("yyyhyu>>",res)
  //         dispatch({
  //             type: WAPPER_ADD,
  //             payload: res,
  //         })
  //     }
  //     ).catch(err =>{
  //         console.log("yyyhyu>>",err)
  //     dispatch({
  //         type: GET_ERRORS,
  //         payload:err.response.data
  //     })
  // }
  // );
};

export const updateWapper = (param) => async (dispatch) => {
  console.log("updateWapper>>>>>", param);
  // return false;
  var wapperUpdateData = new FormData();
  let data = {};
  if (!isEmpty(param.fromAddress))
    wapperUpdateData.append("fromAddress", param.fromAddress);
  data.fromAddress = param.fromAddress;
  if (!isEmpty(param.amount)) {
    wapperUpdateData.append("amount", param.amount);
    data.amount = param.amount
  }

  const wapperRef = doc(db, "wappers", param._id);
  const docRef = await updateDoc(wapperRef, data);
  dispatch({
    type: WAPPER_UPDATE,
    payload: wapperRef,
  })
  toast("The transaction has been updated", {
    position: toast.POSITION.TOP_CENTER,
  });
//   console.log("formUpdateData>>>>>", wapperUpdateData);
//   axios
//     .post("/api/wapper-update", wapperUpdateData)
//     .then((res) =>
//       dispatch({
//         type: WAPPER_UPDATE,
//         payload: res,
//       })
//     )
//     .catch((err) =>
//       dispatch({
//         type: GET_ERRORS,
//         payload: err.response.data,
//       })
//     );
};
